import gql from 'graphql-tag';

export class VideoQueries {
  static videosQuery = gql`
    query Videos($search: String!, $offset: Int!, $limit: Int!, $saved: Boolean) {
      videos(search: $search, offset: $offset, limit: $limit, saved: $saved) {
        videos {
          id
          videoType
          videoTitle
          videoUrl
          thumbUrl
          saved
          published
          createdAt
          usedCount
        }
        totalCount
      }
    }
  `;

  static uploadVideoDoneQuery = gql`
    query UploadVideoDone($videoId: String!) {
      uploadVideoDone(videoId: $videoId) {
        videoUrl
      }
    }
  `;

  static engageVideoQuery = gql`
    query Document($documentId: String!) {
      document(documentId: $documentId) {
        video {
          video {
            id
            thumbUrl
            videoUrl
            status
          }
        }
      }
    }
  `;

  static videoQuery = gql`
    query Video($id: String!) {
      video(id: $id) {
        id
        videoType
        videoTitle
        videoUrl
        thumbUrl
        saved
        published
        createdAt
        usedCount
      }
    }
  `;

  static videoThumbnail = gql`
    query Video($id: String!) {
      video(id: $id) {
        id
        thumbUrl
      }
    }
  `;
}
